import { brand } from '@websrc/App/Helpers/brand'
import { CSProductDetails } from '@websrc/Typings/ContentStack'
import React from 'react'

import { table } from './ComparisonTable.css'

export function ComparisonTableProductHeading({
  product,
  isSticky,
}: {
  product: CSProductDetails
  isSticky: boolean
}) {
  return (
    <>
      <div className={isSticky ? table.thead.sticky.brandName : table.thead.notSticky.brandName}>
        {brand.name}
      </div>
      <div
        className={isSticky ? table.thead.sticky.productName : table.thead.notSticky.productName}
      >
        {product.name}
      </div>
      <div className={isSticky ? table.thead.sticky.sku : table.thead.notSticky.sku}>
        {product.sku_number}
      </div>
    </>
  )
}
